import { Component, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { DialogModule } from 'primeng/dialog';
import { Location, BaseLocation } from '../../../../../core/interfaces/location';
import { TranslocoPipe } from '@jsverse/transloco';
import { CustomButtonComponent } from '../../../../../shared/components/custom-button/custom-button.component';
import { CommonModule } from '@angular/common';
import { firstValueFrom } from 'rxjs';
import { LocationService } from '../../../../../core/api/location.service';
import { HttpErrorResponse } from '@angular/common/http';
import { ApiErrorService } from '../../../../../core/api/api-error.service';

@Component({
  selector: 'app-confirm-locations-dialog',
  standalone: true,
  imports: [FormsModule, DialogModule, TranslocoPipe, CustomButtonComponent, CommonModule],
  templateUrl: './confirm-locations-dialog.component.html',
  styleUrl: './confirm-locations-dialog.component.css'
})
export class ConfirmLocationsDialogComponent {
  visible: boolean = false;

  @Input() pricePerLocation = 15;

  @Input() inactiveLocations!: Location[];
  @Input() reloadLocationsCallbackFunction!: () => void;

  // Dialog error
  dialogErrorMessage: string | null = null;

  deleteClicked: boolean = false;
  confirmClicked: boolean = false;

  showFreeLocation: boolean = false;

  constructor(private locationService: LocationService, private apiError: ApiErrorService) { }

  openModal(showFreeLocation: boolean) {
    this.visible = true;
    this.dialogErrorMessage = null;
    this.deleteClicked = false;

    this.showFreeLocation = showFreeLocation;
  }

  closeModal(): void {
    this.visible = false;
    if (this.reloadLocationsCallbackFunction) {
      this.reloadLocationsCallbackFunction();
    }
  }

  async deleteLocation(location: Location) {
    if (this.deleteClicked || this.confirmClicked) return;
    this.deleteClicked = true;

    try {
      await firstValueFrom(this.locationService.deleteLocation(location.id));

      this.inactiveLocations = this.inactiveLocations.filter(loc => loc.id !== location.id);

      if (this.inactiveLocations.length === 0) {
        this.closeModal();
      }

    } catch (error) {
      let crid = 'UNKNOWN-CRID';

      if (error instanceof HttpErrorResponse) {
        crid = error.headers?.get('x-correlation-id') || 'UNKNOWN-CRID';
      }

      this.dialogErrorMessage = `${await this.apiError.getErrorHeader()} ${await this.apiError.getErrorMessage(crid)}`;
    }

    this.deleteClicked = false;

  }

  async confirmAllLocations() {
    if (this.deleteClicked || this.confirmClicked) return;
    this.confirmClicked = true;

    for (const location of this.inactiveLocations) {
      try {
        await firstValueFrom(this.locationService.confirmLocation(location.id));
      } catch (error) {
        let crid = 'UNKNOWN-CRID';

        if (error instanceof HttpErrorResponse) {
          crid = error.headers?.get('x-correlation-id') || 'UNKNOWN-CRID';
        }

        this.dialogErrorMessage = `${await this.apiError.getErrorHeader()} ${await this.apiError.getErrorMessage(crid)}`;
        return;
      }
    }

    this.inactiveLocations = [];
    this.confirmClicked = false;
    this.closeModal();
  }
}

